import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/schrittmacher_ko.jpg"

const Schrittmacher = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung - Schrittmacherkontrolle </h1>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                        <strong>Schrittmacherkontrolle (Medtronic, Abbott, Biotronik)</strong><br />
                        Schrittmacher müssen in regelmäßigen Abständen nachgesorgt werden.  
                        Bei älteren Geräten mit nachlassender Batterieleistung können engmaschigere Kontrollen erforderlich sein.

                        <br /><br />

                        <strong>Was passiert bei der Schrittmacherkontrolle?</strong><br />
                        Bei der Schrittmacherkontrolle wird mittels eines eigenen firmenspezifischen Abfragegerätes / Programmers das Implantat überprüft.  
                        Der Herzschrittmacher wird abgefragt und seine Einstellung überprüft.  
                        Im Allgemeinen sind nur kurze Tests nötig, um die sichere und fehlerfreie Funktion des Schrittmachers zu kontrollieren.

                        <br /><br />

                        <strong>Wozu benötigt man die Schrittmacherkontrolle?</strong><br />
                        Die regelmäßige Kontrolle dient der Überprüfung der Gesamtfunktion des Schrittmachers.  
                        So werden der Batteriestatus und auch die Elektroden kontrolliert.  
                        Die Programmierung wird den individuellen Bedürfnissen des Patienten angepasst, falls notwendig werden Änderungen vorgenommen.

                        <br /><br />

                        <strong>Wann werden Schrittmacherkontrollen durchgeführt?</strong><br />
                        Nach der Schrittmacherimplantation erfolgt in den meisten Fällen die erste Funktionskontrolle in der implantierenden Klinik.  
                        Da die Elektroden im Herzen einwachsen müssen, kann zumeist die dauerhafte Programmierung etwa 3 Monate nach Implantation erfolgen.

                        <br /><br />

                        <strong>Wie oft erfolgen die Untersuchungen?</strong><br />
                        Bei Beschwerdefreiheit sind Schrittmacherkontrollen zumeist in sechs- bis zwölfmonatigen Abständen üblich.  
                        Bei Problemen mit dem Aggregat können die Abstände selbstverständlich kürzer werden.  
                        Sind alle wichtigen Daten geprüft, wird die Kontrolle in den Schrittmacherausweis für den Patienten eingetragen.
                        <br /><br />
                        <span style={{color:"red"}}> Privatleistung , leider wird diese Leistung nicht von den Kassen (ÖGK, BVAEB, KFA, BVA, SVS, SVA übernommen - Kosten: € 80.- </span>
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Schrittmacher;